module.exports = __webpack_public_path__ + "static/media/ChivvyLogoPrimary-500.0ab0cb0d.svg";